// Material components
import {Grid,Button} from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
// Externals
import PropTypes from "prop-types";
import React from "react";
import { useHistory } from "react-router";
import UnAuthorize from './components/UnAuthorize';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(4),
	},
	content: {
		marginTop: "1rem",
		textAlign: "center",
	},
	image: {
		display: "inline-block",
		marginTop: "50px",
		maxWidth: "100%",
		width: "554px",
	},
}));

const NotFound = (props) => {
	const classes = useStyles();
  const history = useHistory()
	return (
		<div className={classes.root}>
			<Grid container justifyContent="center" spacing={3}>
				<Grid item lg={9} xs={12}>
					<div className={classes.content}>
          <UnAuthorize />
					<h1>403</h1>
					<h2>Not this time, access forbidden!</h2>
					<Button style={{border:"1px solid"}} onClick={() => history.push("/")}> Go Back</Button>
          </div>
				</Grid>
			</Grid>
		</div>
	);
};

NotFound.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(NotFound);
